import React, { useEffect, useState } from "react";
import Layout from "../../layout";
import { useSelector } from "react-redux";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import Services from "../../API/services";
import moment from "moment";
import { Margin, usePDF } from "react-to-pdf";
import { useLocation } from "react-router-dom";
import { showPrice, showRowPrice, StringToJSON } from "utils/utils";

const FoodInvoiceBill = ({ booking, allOrders }) => {
  allOrders = allOrders?.filter(order => order.orderAmount != 0);
  let item = [...allOrders]

  const [textInputs, setTextInputs] = useState({ billNumber: "", name: "", gst: "" });
  const { userDetail } = useSelector(authenticationSeletor);
  const [propertyData, setPropertyData] = useState({});

  let totalGst = 0;
  let netAmt = 0;
  allOrders?.forEach((item) => {
    let orderItem = StringToJSON(item?.orderItems)
    orderItem?.forEach((order) => {
      totalGst = totalGst + order?.taxAmount;
      netAmt = netAmt + order?.totalAmount;
    })
  }
  );
  const cgstVal = totalGst / 2;
  const sgstVal = totalGst / 2;

  const totalAmount = allOrders.reduce((acc, curr) => acc + curr.orderAmount, 0)
  const gstAmount = (totalAmount * 12) / 100;
  const totalGrossAmount = totalAmount / (1 + (12 / 100))

  const { toPDF, targetRef } = usePDF({
    method: "open",
    filename: "roomInvoice.pdf",
    page: {
      margin: Margin.SMALL,
      format: "A6",
    },
    canvas: {
      mimeType: "image/png",
      qualityRatio: 1,
    },
  });

  useEffect(() => { getPropertyDetail(); }, []);

  const getPropertyDetail = async () => {
    try {
      const res = await Services.property.getSinglePropertyService(
        userDetail?.propertyId,
        true
      );
      if (res.status == 200) { setPropertyData(res?.data?.data); }
    } catch (error) { console.log("Error in getPropertyDetail") }
  };

  let myAllOrders = allOrders[0]?.orderItems

  const totalOrderCount = allOrders.reduce((acc, curr) => {
    const xOrders = JSON.parse(curr.orderItems);
    return acc + xOrders.length
  }, 0)

  const baseAmount = booking?.totalFoodAmount / (1 + 5 / 100);
  const gstAmounts = booking?.totalFoodAmount - baseAmount;

  const sgst = gstAmounts / 2;
  const cgst = gstAmounts / 2;

  return (
    <div className="foodInvoice print-font-lg">
      <div className=" bg-white py-2 foodPdf" ref={targetRef}>
        <span className="text-black gstText text-center d-block" style={{ fontSize: "16px" }}>
          GSTIN No.: {propertyData?.gstNumber}
        </span>
        <div className="text-center text-black content">
          <h1>{propertyData?.name}</h1>
          <span style={{ fontSize: '16px' }}>{propertyData?.address}</span>
          <span style={{ fontSize: '16px' }}>Contact No.:{propertyData?.ownerMobile}</span>
          <span style={{ fontSize: '16px' }}>
            Room Service
          </span>
        </div>
        <div className="borderedDiv">
          <p>
            Bill Number: - {allOrders[0]?.BookingHotel?.bookingCode}
          </p>
          <p>
            Date:{" "}
            <span>{moment(item?.createdAt).format("DD-MM-YYYY")}</span>
          </p>
        </div>
        <div className="borderedDiv">
          <p>
            Room Number: <span>{allOrders[0]?.roomNumber}</span>
          </p>
          <p>
            Booking ID: <span>{allOrders[0]?.BookingHotel?.id}</span>
          </p>
        </div>

        {allOrders?.map((mainItem, i) => {
          const mainOrderItem = StringToJSON(mainItem.orderItems)
          return (
            <div key={i + 1} style={{ padding: '5px' }} className={((i + 1) % 1 == 0) ? 'page-break' : ''}>
              <div className="borderedDiv" style={{ borderTop: 'none' }}>
                <p>Order Number: <span>{mainItem.id}</span></p>
                <p>Order Date & Time: <span>{moment(mainItem?.createdAt).format('DD-MM-YYYY HH:mm')}</span></p>
              </div>
              <div className="borderedDiv">
                <p className="w-25 fw-700">Item Name</p>
                <p className="w-25 justify-content-end">Rate</p>
                <p className="w-25 justify-content-center">Qty</p>
                <p className="w-25 justify-content-end">Amount</p>
              </div>
              {mainOrderItem?.map((data, ind) => (
                <div className="borderedDiv other" key={ind}>
                  <p className="w-25">{data?.name}</p>
                  <p className="w-25 justify-content-end">{showRowPrice(data?.amountBeforeTax)}</p>
                  <p className="w-25 justify-content-center">{data?.qty}</p>
                  <p className="w-25 justify-content-end">{(data?.qty * data?.amountBeforeTax).toFixed(2)}</p>
                </div>
              ))}
            </div>
          )
        })}

        <div className="borderedDiv flex-column p-1">
          <p className="justify-content-between w-100">
            Gross Amount: <span>{showRowPrice(booking?.totalFoodAmount / 105 * 100)}</span>
          </p>
          <p className="justify-content-between w-100">
            Discount ({booking?.foodDiscountPercentage}%) Amount:
            <span>{booking?.discountOnFood}</span>
          </p>
          <p className="justify-content-between w-100">
            SGST:
            {/* <span>{showRowPrice(sgst)}</span> */}
            <span>
              {((booking?.totalFoodAmountBeforeGST - (booking?.discountOnFood || 0)) * 2.5 / 100).toFixed(2)}
            </span>
          </p>
          <p className="justify-content-between w-100">
            CGST:
            {/* <span>{showRowPrice(cgst)}</span> */}
            <span>
              {((booking?.totalFoodAmountBeforeGST - (booking?.discountOnFood || 0)) * 2.5 / 100).toFixed(2)}
            </span>
          </p>
          <p className="justify-content-between w-100">
            Total Amount:
            {/* <span>{showPrice(totalAmount)}</span> */}
            <span>{booking.collectedFoodAmout}</span>
          </p>

          <p className="justify-content-between w-100">
            Paid Amount:
            {/* <span>{showPrice(booking?.collectedFoodAmout)}</span> */}
            <span>{booking?.collectedFoodAmout}</span>
          </p>
        </div>
        <div className="borderedDiv flex-column align-items-start">
          <p>
            Customer Name:{" "}
            {booking?.User?.name}
          </p>
          <p>
            Customer GST:
            <input
              type="text"
              className="noCenter mw-100"
              style={{ borderWidth: textInputs.gst.length > 0 ? 0 : 1 }}
              value={textInputs.gst}
              onChange={(e) =>
                setTextInputs({ ...textInputs, gst: e.target.value })
              }
            />
          </p>
        </div>
      </div>
    </div>
  );
};

export default FoodInvoiceBill;
